import { GhostState, DefaultDurations } from './types'

interface Options {
  ghost: GhostState | null
  draftDurations: DefaultDurations
  hasCollision: (iso: string, dur: DefaultDurations, techId: string, excludeId?: string, excludeTaskId?: number, fullDayTechId?: string) => boolean
  appointmentId: string | undefined
  isFullDay: boolean
}

/**
 * Returns a per-row collision checker for the ghost block.
 * Call once at widget level; the returned function is safe to call per-row inside a map.
 */
export function useGhostCollision({ ghost, draftDurations, hasCollision, appointmentId, isFullDay }: Options) {
  return function isGhostColliding(
    working: boolean,
    shiftStartHour: number | null,
    shiftEndHour: number | null,
  ): boolean {
    if (!ghost) return false

    if (
      hasCollision(
        ghost.anfahrtStartIso,
        draftDurations,
        ghost.technicianId,
        appointmentId,
        undefined,
        isFullDay ? ghost.technicianId : undefined,
      )
    ) return true

    if (!working) return true

    const blockStartH =
      new Date(ghost.anfahrtStartIso).getHours() +
      new Date(ghost.anfahrtStartIso).getMinutes() / 60
    const totalMin =
      draftDurations.plannedTravelDuration +
      draftDurations.plannedWorkDuration +
      draftDurations.plannedDepartureDuration
    const blockEndH = blockStartH + totalMin / 60

    return (
      (shiftStartHour != null && blockStartH < shiftStartHour) ||
      (shiftEndHour != null && blockEndH > shiftEndHour)
    )
  }
}
